(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temple-projects"] && !Shopify.designMode) return;
  try {
    
/**
 * Projects chips are a menu: hover (mouse) or tap opens that project's
 * copy + photos and closes the others. The page does not scroll — the
 * story swaps in place under the chips. Tapping the open chip keeps it
 * open — collapsing to an empty roster reads as missing content.
 *
 * Plain HTMLElement, same as temple-weekly-runs: the section javascript tag
 * is compiled into a classic (non-module) bundle, so an `import` here is a
 * syntax error that kills every section's JS in compiled_assets/scripts.js.
 * (Do not write the tag itself inside this comment — Liquid would parse it.)
 */
class TempleProjectsComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    // pointerenter does not bubble; a capture listener still fires for
    // pointers entering the chips (mouse only — hover opens like a menu)
    this.addEventListener('pointerenter', this.#onPointerEnter, true);

    // Homepage covers link here with #brand. The inline script usually
    // opens that pill before this bundle runs; this catches a late hash.
    this.#openFromHash();

    // Closed brands are display:none + loading="lazy", so their photos only
    // start downloading the moment a pill is pressed — that's the pop-in on
    // swap. Once the page has loaded and gone idle, warm the closed brands
    // one at a time (flip lazy -> eager; display:none eager images still
    // download) so switching is instant, without slowing the first paint.
    if (document.readyState === 'complete') {
      this.#warmGalleries();
    } else {
      window.addEventListener('load', () => this.#warmGalleries(), { once: true });
    }
  }

  #warmGalleries() {
    const projects = Array.from(this.querySelectorAll('.temple-projects__project'));
    const idle = window.requestIdleCallback
      ? (fn) => window.requestIdleCallback(fn, { timeout: 1500 })
      : (fn) => window.setTimeout(fn, 300);

    let index = 0;
    const warmNext = () => {
      const project = projects[index];
      index += 1;
      if (!project) return;

      // Skip the open brand — its photos are already loading in view
      if (!project.classList.contains('is-open')) {
        for (const img of project.querySelectorAll('img[loading="lazy"]')) {
          img.loading = 'eager';
        }
      }

      if (index < projects.length) idle(warmNext);
    };

    idle(warmNext);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('pointerenter', this.#onPointerEnter, true);
  }

  /**
   * @param {Event} event
   */
  #onClick = (event) => {
    const button = this.#nameFromEvent(event);
    if (!button) return;

    this.#showProject(button);
  };

  /**
   * @param {PointerEvent} event
   */
  #onPointerEnter = (event) => {
    if (event.pointerType === 'touch') return;

    const button = this.#nameFromEvent(event);
    if (!button) return;

    this.#showProject(button);
  };

  /**
   * @param {Event} event
   * @returns {HTMLElement | null}
   */
  #nameFromEvent(event) {
    const raw = event.target;
    if (!(raw instanceof Element)) return null;

    const button = raw.closest('.temple-projects__name[aria-controls]');
    if (!(button instanceof HTMLElement) || !this.contains(button)) return null;

    return button;
  }

  #openFromHash() {
    const raw = window.location.hash.replace(/^#/, '');
    if (!/^[a-z0-9-]+$/.test(raw)) return;

    const button = this.querySelector(`.temple-projects__name[data-project="${raw}"]`);
    if (!(button instanceof HTMLElement)) return;

    this.#showProject(button);
  }

  /**
   * @param {HTMLElement} button
   */
  #showProject(button) {
    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;

    if (!panel) return;

    if (button.getAttribute('aria-expanded') !== 'true') {
      // Hold the tallest panel height seen (copy + photos) so the band
      // never shrinks mid-swap and nudges the page
      const openPanel = this.querySelector('.temple-projects__project.is-open .temple-projects__project-content');

      if (openPanel) {
        const held = parseFloat(this.style.getPropertyValue('--projects-panel-min-height')) || 0;
        const next = Math.max(held, openPanel.getBoundingClientRect().height);
        this.style.setProperty('--projects-panel-min-height', `${next}px`);
      }

      for (const name of this.querySelectorAll('.temple-projects__name[aria-controls]')) {
        const match = name.getAttribute('aria-controls') === panelId;
        name.setAttribute('aria-expanded', match ? 'true' : 'false');
      }

      const incoming = panel.closest('.temple-projects__project');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Reopening a project that is still dissolving out: cancel its leave
      // so it doesn't stay lifted / faded once it becomes the open one.
      incoming?.classList.remove('is-leaving');

      for (const project of this.querySelectorAll('.temple-projects__project')) {
        // A press is a swap: from here every story drifts in, including
        // the one that was settled on screen at load.
        project.classList.remove('is-settled');

        if (project === incoming) continue;

        const wasOpen = project.classList.contains('is-open');
        project.classList.remove('is-open');
        const otherPanel = project.querySelector('.temple-projects__project-content');

        if (wasOpen && !reduceMotion) {
          // Crossfade: keep it rendered and let it dissolve out on top of
          // the incoming story. Hide it only once its fade has finished
          // (and only if it hasn't been reopened in the meantime).
          project.classList.add('is-leaving');

          const finish = (event) => {
            if (event && event.animationName !== 'temple-project-swap-out') return;
            project.classList.remove('is-leaving');
            project.removeEventListener('animationend', finish);
            if (!project.classList.contains('is-open') && otherPanel) otherPanel.hidden = true;
          };

          project.addEventListener('animationend', finish);
          // Safety net if animationend never fires (e.g. tab backgrounded)
          setTimeout(finish, 800);
        } else {
          project.classList.remove('is-leaving');
          if (otherPanel) otherPanel.hidden = true;
        }
      }

      panel.hidden = false;
      incoming?.classList.add('is-open');
    }
  }
}

if (!customElements.get('temple-projects-component')) {
  customElements.define('temple-projects-component', TempleProjectsComponent);
}

if (!customElements.get('temple-run-gallery')) {
  customElements.define(
    'temple-run-gallery',
    class TempleRunGallery extends HTMLElement {
      #userScrolled = false;

      connectedCallback() {
        this.addEventListener(
          'pointerdown',
          () => {
            this.#userScrolled = true;
          },
          { once: true, passive: true }
        );

        const center = () => {
          if (this.#userScrolled) return;

          // Centering is a mobile-carousel behavior. The desktop landing
          // filmstrip is also a scroller, but it must start at the first
          // photo, not auto-scroll to the middle one.
          if (window.matchMedia('(min-width: 750px)').matches) return;

          // Standalone Projects page: the strip starts on the sentence's
          // left edge. Centering the middle photo pulled the row off it.
          if (this.classList.contains('temple-projects__images')) return;

          // Homepage door: Nike is the first real cover, and both covers
          // of the last brand sit before it. Park Nike in the center so
          // the nearer one peeks on the left and a swipe left reaches both.
          if (this.classList.contains('temple-projects__door-strip')) {
            const lead = this.querySelector('.temple-projects__door-item--lead');
            if (!lead) return;

            const galleryBox = this.getBoundingClientRect();
            const leadBox = lead.getBoundingClientRect();
            if (galleryBox.width === 0 || leadBox.width === 0) return;

            const delta = leadBox.left + leadBox.width / 2 - (galleryBox.left + galleryBox.width / 2);
            if (Math.abs(delta) < 2) return;

            this.classList.add('is-centering');
            this.scrollLeft += delta;
            requestAnimationFrame(() => {
              this.classList.remove('is-centering');
            });
            return;
          }

          const photos = this.querySelectorAll('img, video');
          if (photos.length < 2) return;

          const middle = photos[Math.floor(photos.length / 2)];
          const galleryBox = this.getBoundingClientRect();
          const photoBox = middle.getBoundingClientRect();

          if (galleryBox.width === 0 || photoBox.width === 0) return;

          const delta = photoBox.left + photoBox.width / 2 - (galleryBox.left + galleryBox.width / 2);
          if (Math.abs(delta) < 2) return;

          this.classList.add('is-centering');
          this.scrollLeft += delta;

          requestAnimationFrame(() => {
            this.classList.remove('is-centering');
          });
        };

        requestAnimationFrame(center);
        new ResizeObserver(center).observe(this);

        for (const media of this.querySelectorAll('img, video')) {
          if (media instanceof HTMLImageElement && media.complete) continue;
          // Lazy videos load when scrolled to, long after the strip has
          // settled, and their 4:5 box is set in CSS. Centering on their
          // first frame would yank the strip back to the lead cover.
          if (media instanceof HTMLVideoElement && 'templeLazyVideo' in media.dataset) continue;
          media.addEventListener('load', center, { once: true });
          media.addEventListener('loadeddata', center, { once: true });
        }

        this.#watchVideos();
      }

      /**
       * Videos rendered by snippets/temple-video.liquid carry their source
       * URLs in data-src and preload nothing. Fetch and play one when it
       * comes near the viewport; pause it when it leaves so a strip of
       * covers never has every clip decoding at once.
       */
      #watchVideos() {
        const videos = this.querySelectorAll('video[data-temple-lazy-video]');
        if (videos.length === 0) return;

        /** @param {HTMLVideoElement} video */
        const wake = (video) => {
          if (video.dataset.templeLazyVideo === 'loaded') return;
          video.dataset.templeLazyVideo = 'loaded';
          for (const source of video.querySelectorAll('source[data-src]')) {
            source.setAttribute('src', source.getAttribute('data-src') ?? '');
            source.removeAttribute('data-src');
          }
          video.load();
        };

        const nearby = new IntersectionObserver(
          (entries) => {
            for (const { target, isIntersecting } of entries) {
              if (!(target instanceof HTMLVideoElement)) continue;
              if (isIntersecting) {
                wake(target);
                target.play().catch(() => {});
              } else if (!target.paused) {
                target.pause();
              }
            }
          },
          { rootMargin: '25% 25%', threshold: 0 }
        );

        for (const video of videos) nearby.observe(video);

        const whenVisible = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            center();
            if (this.clientWidth > 0) whenVisible.disconnect();
          },
          { threshold: 0.01 }
        );

        whenVisible.observe(this);
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temple-run"] && !Shopify.designMode) return;
  try {
    
  /**
   * Photo strip: lines the middle image up in the viewport so neighbours
   * peek on both sides. Snap is turned off for that jump — otherwise
   * mandatory snap pulls the strip back to the first photo. On desktop
   * (and on the run pages) the photos are a grid with no overflow, so
   * this is a no-op.
   */
  class TempleRunGallery extends HTMLElement {
    /** Stops the auto-centering once the visitor swipes the strip themselves */
    #userScrolled = false;

    connectedCallback() {
      this.addEventListener(
        'pointerdown',
        () => {
          this.#userScrolled = true;
        },
        { once: true, passive: true }
      );

      const center = () => {
        if (this.#userScrolled) return;

        // Centering is a mobile-carousel behavior. The desktop filmstrips
        // are also scrollers, but they must start at the first photo, not
        // auto-scroll to the middle one.
        if (window.matchMedia('(min-width: 750px)').matches) return;

        // Standalone Projects page: the strip starts on the sentence's
        // left edge. Centering the middle photo pulled the row off it.
        // This copy has to match the one in temple-projects and temple-weekly-runs:
        // only the first definition of the element wins.
        if (this.classList.contains('temple-projects__images')) return;

        const photos = this.querySelectorAll('img, video');
        if (photos.length < 2) return;

        const middle = photos[Math.floor(photos.length / 2)];
        const galleryBox = this.getBoundingClientRect();
        const photoBox = middle.getBoundingClientRect();

        if (galleryBox.width === 0 || photoBox.width === 0) return;

        this.classList.add('is-centering');
        this.scrollLeft +=
          photoBox.left + photoBox.width / 2 - (galleryBox.left + galleryBox.width / 2);

        requestAnimationFrame(() => {
          this.classList.remove('is-centering');
        });
      };

      requestAnimationFrame(center);
      window.addEventListener('load', center, { once: true });
      new ResizeObserver(center).observe(this);

      // Off-screen strips often ignore scrollLeft until they enter view
      // (the homepage snap). Re-center the first time this one appears.
      const whenVisible = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          center();
          if (this.clientWidth > 0) whenVisible.disconnect();
        },
        { threshold: 0.01 }
      );

      whenVisible.observe(this);

      for (const img of this.querySelectorAll('img')) {
        if (!img.complete) img.addEventListener('load', center, { once: true });
      }
    }
  }

  if (!customElements.get('temple-run-gallery')) {
    customElements.define('temple-run-gallery', TempleRunGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temple-shoe-test"]) return;
  try {
    
  /**
   * The Forms app paints inside an open shadow root, in Arial with rounded
   * fields. Pull the type and the field rules in line with the band once
   * the embed has rendered. Checkboxes and radios keep their own controls.
   */
  const shoeTest = document.querySelector('.temple-shoe-test');

  if (shoeTest && shoeTest.dataset.formDressed !== 'true') {
    shoeTest.dataset.formDressed = 'true';

    const font = getComputedStyle(shoeTest).fontFamily;

    const paint = (embed) => {
      const shadow = embed.shadowRoot;

      if (!shadow) return;

      if (!shadow.querySelector('[data-temple-form-style]')) {
        const style = document.createElement('style');
        style.setAttribute('data-temple-form-style', '');
        /* The Forms app sets its own label and button colours inside the
           shadow root. !important is the only way those lose to the page. */
        style.textContent = `
          :host {
            --form-text-color: #ffffff;
            --body-text-color: #ffffff;
            --heading-text-color: #ffffff;
            --form-placeholder-color: #ffffff;
            --button-text-color: #ffffff;
            --button-background-color: transparent;
            color: #ffffff;
          }

          label,
          legend,
          p,
          span,
          h1,
          h2,
          h3,
          a,
          input,
          textarea,
          select {
            color: #ffffff !important;
            -webkit-text-fill-color: #ffffff !important;
            font-family: ${font} !important;
          }

          input::placeholder,
          textarea::placeholder {
            color: #ffffff !important;
            opacity: 1 !important;
            -webkit-text-fill-color: #ffffff !important;
          }

          h1,
          h2,
          h3 {
            margin: 0 !important;
            font-size: 0.8125rem !important;
            font-weight: 400 !important;
            letter-spacing: 0.06em !important;
            line-height: 1.3 !important;
          }

          form {
            display: flex !important;
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 0.75rem !important;
          }

          form > *,
          form div {
            position: relative !important;
            margin: 0 !important;
            padding-block: 0 !important;
            min-height: 0 !important;
            height: auto !important;
            overflow: visible !important;
          }

          label {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            transform: none !important;
            display: block !important;
            margin: 0 !important;
            font-size: 0.75rem !important;
            font-weight: 400 !important;
            letter-spacing: 0.06em !important;
            line-height: 1.2 !important;
            text-transform: uppercase !important;
            pointer-events: none !important;
          }

          legend {
            text-transform: uppercase !important;
            letter-spacing: 0.06em !important;
          }

          p {
            margin: 0.45rem 0 0 !important;
            font-size: 0.75rem !important;
            font-weight: 400 !important;
            letter-spacing: 0 !important;
            line-height: 1.4 !important;
          }

          input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
          textarea,
          select {
            margin: 0 !important;
            padding: 0.95rem 0 0.2rem !important;
            min-height: 0 !important;
            height: auto !important;
            font-size: 0.875rem !important;
            font-weight: 400 !important;
            line-height: 1.2 !important;
            background: transparent !important;
            background-color: transparent !important;
            border: 0 !important;
            border-bottom: 1px solid rgb(255 255 255 / 70%) !important;
            border-radius: 0 !important;
            box-shadow: none !important;
          }

          button {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            align-self: flex-start !important;
            width: fit-content !important;
            height: 1.5rem !important;
            min-height: 1.5rem !important;
            margin: 0 !important;
            padding: 0 1.25rem !important;
            background: none !important;
            background-color: transparent !important;
            color: #ffffff !important;
            -webkit-text-fill-color: #ffffff !important;
            border: 1px solid rgb(255 255 255 / 60%) !important;
            border-radius: 4px !important;
            box-shadow: none !important;
            font-family: ${font} !important;
            font-size: 0.75rem !important;
            font-weight: 400 !important;
            letter-spacing: 0 !important;
            line-height: 1 !important;
            text-transform: uppercase !important;
            white-space: nowrap !important;
          }

          button:hover,
          button:focus-visible {
            background: #ffffff !important;
            background-color: #ffffff !important;
            color: #422337 !important;
            -webkit-text-fill-color: #422337 !important;
            border-color: #ffffff !important;
          }

          input:focus-visible,
          textarea:focus-visible,
          select:focus-visible,
          button:focus-visible {
            outline: 2px solid #ffffff;
            outline-offset: 3px;
          }
        `;
        shadow.appendChild(style);
      }

      const heading = shadow.querySelector('h1, h2, h3');
      const form = shadow.querySelector('form');

      if (heading) {
        heading.style.setProperty('margin', '0', 'important');

        const header = heading.parentElement;

        if (header && header !== form && header !== shadow) {
          header.style.setProperty('margin', '0', 'important');
          header.style.setProperty('padding', '0', 'important');
          header.style.setProperty('gap', '0', 'important');
          header.style.setProperty('min-height', '0', 'important');
        }
      }

      if (form) {
        form.style.setProperty('margin-top', '0', 'important');
        form.style.setProperty('padding-top', '0', 'important');
      }
    };

    const scan = () => {
      const embeds = shoeTest.querySelectorAll('shopify-forms-embed, form-embed');

      for (const embed of embeds) {
        paint(embed);
      }
    };

    scan();

    const observer = new MutationObserver(scan);
    observer.observe(shoeTest, { childList: true, subtree: true });

    let tries = 0;
    const timer = window.setInterval(() => {
      scan();
      tries += 1;

      if (tries > 20) window.clearInterval(timer);
    }, 300);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temple-weekly-runs"] && !Shopify.designMode) return;
  try {
    
  /**
   * A motion token (assets/temple-motion.css) in milliseconds, so script
   * timings stay in step with the CSS transitions they wait for.
   * @param {string} name
   * @param {number} fallback
   */
  function motionMs(name, fallback) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const value = Number.parseFloat(raw);

    if (!Number.isFinite(value)) return fallback;

    return raw.endsWith('ms') ? value : value * 1000;
  }

  /**
   * Homepage weekly runs: tap a slab to grow its page out of the band.
   * Plain HTMLElement so clicks do not depend on the theme Component hook.
   */
  class TempleWeeklyRuns extends HTMLElement {
    /** @type {ReturnType<typeof setTimeout> | null} */
    #closeTimer = null;

    /** @type {IntersectionObserver | null} */
    #activeObserver = null;

    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      document.addEventListener('keydown', this.#onKeydown);
      this.#watchActive();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      document.removeEventListener('keydown', this.#onKeydown);
      this.#activeObserver?.disconnect();
      document.documentElement.classList.remove('temple-runs-page-open');
    }

    /**
     * @param {MouseEvent} event
     */
    #onClick = (event) => {
      if (event.defaultPrevented) return;

      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const closeButton = target instanceof Element ? target.closest('.temple-runs__page-close') : null;
      const fromPointer = event.detail > 0;
      if (closeButton && this.contains(closeButton)) {
        event.preventDefault();
        this.#closeAll({ fromPointer });
        return;
      }

      const teaser = target instanceof Element ? target.closest('.temple-runs__teaser') : null;
      if (!teaser || !this.contains(teaser)) return;
      if (this.hasAttribute('data-runs-static')) return;

      const run = teaser.closest('.temple-runs__run');
      if (!(run instanceof HTMLElement)) return;

      event.preventDefault();

      if (run.classList.contains('is-open')) {
        this.#closeAll({ fromPointer });
        return;
      }

      this.#closeAll({ instant: true });
      this.#open(run, fromPointer);
    };

    /**
     * @param {Object} [options]
     * @param {boolean} [options.instant]
     */
    closeAll(options) {
      this.#closeAll(options ?? {});
    }

    /**
     * Open a run from the header (WEEKLY RUNS submenu) by a normalized key
     * such as "communityrun" or "womensrun".
     * @param {string} key
     */
    openByKey(key) {
      if (this.hasAttribute('data-runs-static')) return false;

      const normalized = this.#normalize(key);
      if (!normalized) return false;

      const runs = this.querySelectorAll('.temple-runs__run');

      for (const run of runs) {
        if (!(run instanceof HTMLElement)) continue;
        if (this.#normalize(run.dataset.runKey) !== normalized) continue;

        this.#closeAll({ instant: true });
        this.#open(run);
        return true;
      }

      return false;
    }

    /**
     * @param {KeyboardEvent} event
     */
    #onKeydown = (event) => {
      if (this.querySelector('.is-pointer-focus')) {
        for (const button of this.querySelectorAll('.is-pointer-focus')) {
          button.classList.remove('is-pointer-focus');
        }
      }

      if (event.key !== 'Escape') return;
      if (!this.hasAttribute('data-expanded')) return;

      event.preventDefault();
      this.#closeAll();
    };

    // This chapter is "on" while it holds the middle of the screen — the
    // same line the header's section watcher reads, so the two never
    // disagree mid-swipe (a ratio threshold kept WEEKLY RUNS filled while
    // the header had already gone over to Projects). The root margins
    // squeeze the root to that one line; isIntersecting is true whenever
    // the band crosses it.
    #watchActive() {
      const section = this.closest('.shopify-section') || this;

      this.#activeObserver = new IntersectionObserver(
        (entries) => {
          const on = entries.some((entry) => entry.isIntersecting);
          this.toggleAttribute('data-active', on);
          section.toggleAttribute('data-current', on);
          this.#markHeader(on);
        },
        { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
      );

      this.#activeObserver.observe(section);
    }

    /**
     * @param {boolean} on
     */
    #markHeader(on) {
      const header = document.getElementById('header-component');
      if (!header) return;

      if (on) header.setAttribute('data-landing-section', 'runs');
      else if (header.getAttribute('data-landing-section') === 'runs') {
        header.removeAttribute('data-landing-section');
      }

      for (const link of header.querySelectorAll('.menu-list__link')) {
        const nav = link.getAttribute('data-landing-nav');
        const label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        const isRuns = nav === 'runs' || label.includes('weekly');
        link.classList.toggle('is-landing-current', on && isRuns);
      }
    }

    /**
     * @param {HTMLElement} run
     * @param {boolean} [fromPointer]
     */
    #open(run, fromPointer = false) {
      const page = run.querySelector('.temple-runs__page');
      const teaser = run.querySelector('.temple-runs__teaser');
      const closeButton = run.querySelector('.temple-runs__page-close');
      if (!(page instanceof HTMLElement)) return;

      const from = run.getBoundingClientRect();
      const headerH = this.#headerHeight();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (teaser instanceof HTMLElement) {
        teaser.setAttribute('aria-expanded', 'true');
      }

      run.classList.add('is-open');
      this.setAttribute('data-expanded', '');
      document.documentElement.classList.add('temple-runs-page-open');

      const unfold = () => {
        page.style.top = `${headerH}px`;
        page.style.height = `calc(100svh - ${headerH}px)`;
        page.classList.add('is-out');
        this.templeRunsScroll?.schedule(run);
      };

      if (this.#closeTimer) {
        clearTimeout(this.#closeTimer);
        this.#closeTimer = null;
      }

      page.classList.remove('is-out');
      page.style.top = `${from.top}px`;
      page.style.height = `${Math.max(from.height, 1)}px`;
      page.hidden = false;
      page.classList.add('is-visible');

      if (reduceMotion) {
        unfold();
      } else {
        // Mirror of the close, in reverse (see the inline script, which
        // owns the tap): the page appears on its slab transparent and
        // fills in over a stride, so the teaser title dissolves into the
        // slab colour; two steps in, the clean slab folds up. Reading the
        // box commits the start values so the fold transitions.
        page.classList.add('is-fading');
        page.getBoundingClientRect();
        page.classList.remove('is-fading');
        this.#closeTimer = setTimeout(unfold, motionMs('--motion-step', 90) * 2);
      }

      this.#focusControl(closeButton, fromPointer);
    }

    /**
     * @param {Object} [options]
     * @param {boolean} [options.instant]
     * @param {boolean} [options.fromPointer]
     */
    #closeAll(options = {}) {
      const instant = options.instant === true;
      const fromPointer = options.fromPointer === true;
      this.templeRunsScroll?.release();
      const open = this.querySelector('.temple-runs__run.is-open');
      const teaser = open?.querySelector('.temple-runs__teaser');

      if (this.#closeTimer) {
        clearTimeout(this.#closeTimer);
        this.#closeTimer = null;
      }

      this.removeAttribute('data-expanded');

      for (const button of this.querySelectorAll('.temple-runs__teaser')) {
        button.setAttribute('aria-expanded', 'false');
      }

      // Scroll stays locked until the very end — unlocking early lets the
      // page re-snap under the animation, so the page lands a few px off
      // its slab and hops at the last frame
      const finish = () => {
        document.documentElement.classList.remove('temple-runs-page-open');
        open?.classList.remove('is-open');
        this.#hidePages();
        // preventScroll: focusing the teaser must not nudge the snap
        // scroll — that reads as a jump right as the page disappears
        this.#focusControl(teaser, fromPointer);
      };

      if (!(open instanceof HTMLElement)) {
        finish();
        return;
      }

      const page = open.querySelector('.temple-runs__page');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (instant || reduceMotion || !(page instanceof HTMLElement)) {
        finish();
        return;
      }

      // Mirror of the open, timed off the motion tokens the CSS uses:
      // the copy fades for a stride (see the page-body transition); two
      // steps in, with most of it gone, the page starts shrinking back
      // into its slab.
      const step = motionMs('--motion-step', 90);
      const stride = motionMs('--motion-stride', 350);
      const stretch = motionMs('--motion-stretch', 700);

      page.classList.remove('is-out');
      page.classList.add('is-closing');

      this.#closeTimer = setTimeout(() => {
        // Measure the slab now, not at close start: nothing has shifted
        // in the meantime, so the page lands exactly on it. The copy is
        // nearly invisible, so the scroll reset doesn't jump either.
        const from = open.getBoundingClientRect();
        page.scrollTop = 0;
        page.style.top = `${from.top}px`;
        page.style.height = `${Math.max(from.height, 1)}px`;

        // The fold's ease-out does ~90% of its travel by 60% of its time,
        // so the dissolve rides the slow tail: the page is fully
        // transparent by the time it lands, and the teaser never swaps
        // in visibly.
        this.#closeTimer = setTimeout(() => {
          page.classList.add('is-fading');
          this.#closeTimer = setTimeout(finish, stride + 30);
        }, Math.round(stretch * 0.6));
      }, step * 2);
    }

    /**
     * Focus a slab or page title without leaving iOS's selection box.
     * Pointer taps set is-pointer-focus so the white focus ring stays off;
     * keyboard focus does not.
     * @param {Element | null | undefined} button
     * @param {boolean} fromPointer
     */
    #focusControl(button, fromPointer) {
      if (!(button instanceof HTMLElement)) return;

      for (const quiet of this.querySelectorAll('.is-pointer-focus')) {
        quiet.classList.remove('is-pointer-focus');
      }

      if (fromPointer) button.classList.add('is-pointer-focus');
      button.focus({ preventScroll: true });

      if (!fromPointer) return;

      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) selection.removeAllRanges();
      requestAnimationFrame(() => {
        const next = window.getSelection();
        if (next && next.rangeCount > 0) next.removeAllRanges();
      });
    }

    #hidePages() {
      const pages = this.querySelectorAll('.temple-runs__page');

      for (const page of pages) {
        page.hidden = true;
        page.classList.remove('is-visible', 'is-out', 'is-fading', 'is-closing', 'is-swap');
        if (page instanceof HTMLElement) {
          page.style.top = '';
          page.style.height = '';
        }
      }

      for (const run of this.querySelectorAll('.temple-runs__run')) {
        run.classList.remove('is-open');
      }
    }

    #headerHeight() {
      const header = document.querySelector('.header');
      return Math.round(header?.getBoundingClientRect().height ?? 64);
    }

    #announceChange() {
      this.dispatchEvent(
        new CustomEvent('temple:runs-change', { bubbles: true })
      );
    }

    /**
     * @param {string | undefined} value
     */
    #normalize(value) {
      return (value ?? '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    }
  }

  if (!customElements.get('temple-weekly-runs')) {
    customElements.define('temple-weekly-runs', TempleWeeklyRuns);
  }

  if (!customElements.get('temple-run-gallery')) {
    customElements.define(
      'temple-run-gallery',
      class TempleRunGallery extends HTMLElement {
        #userScrolled = false;

        connectedCallback() {
          this.addEventListener(
            'pointerdown',
            () => {
              this.#userScrolled = true;
            },
            { once: true, passive: true }
          );

          const center = () => {
            if (this.#userScrolled) return;

            // Centering is a mobile-carousel behavior. The desktop
            // filmstrips are also scrollers, but they must start at the
            // first photo, not auto-scroll to the middle one.
            if (window.matchMedia('(min-width: 750px)').matches) return;

            // Standalone Projects page: the strip starts on the sentence's
            // left edge. Centering the middle photo pulled the row off it.
            // This copy has to match the one in temple-projects and temple-run:
            // only the first definition of the element wins.
            if (this.classList.contains('temple-projects__images')) return;

            const photos = this.querySelectorAll('img, video');
            if (photos.length < 2) return;

            const middle = photos[Math.floor(photos.length / 2)];
            const galleryBox = this.getBoundingClientRect();
            const photoBox = middle.getBoundingClientRect();

            if (galleryBox.width === 0 || photoBox.width === 0) return;

            this.classList.add('is-centering');
            this.scrollLeft +=
              photoBox.left + photoBox.width / 2 - (galleryBox.left + galleryBox.width / 2);

            requestAnimationFrame(() => {
              this.classList.remove('is-centering');
            });
          };

          requestAnimationFrame(center);
          window.addEventListener('load', center, { once: true });
          new ResizeObserver(center).observe(this);

          const whenVisible = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              center();
              if (this.clientWidth > 0) whenVisible.disconnect();
            },
            { threshold: 0.01 }
          );

          whenVisible.observe(this);

          for (const img of this.querySelectorAll('img')) {
            if (!img.complete) img.addEventListener('load', center, { once: true });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
